/** Helper class for parsing mime types and file extensions for audio files */
export class Mime {
    /** All supported mime types for the application */
    static PreferredMimes = [
        { name: "audio/webm", ext: "webm" },
        { name: "audio/ogg", ext: "ogg" },
        { name: "audio/wav", ext: "wav" },
        { name: "audio/flac", ext: "flac" },
        { name: "audio/mpeg", ext: "mp3" },
        { name: "audio/mp4", ext: "m4a" },
    ];
    /** All supported mime types keyed of the mime type */
    static MimeToExtension = new Map(this.PreferredMimes.map(value => [value.name, value.ext]));
    /** All supported mimes keyed to extension */
    static ExtensionToMime = new Map(this.PreferredMimes.map(value => [value.ext, value.name]));
    /** Normalize a mime type from a string provided by the browser (e.g. "audio/ogg; codecs=opus", "audio/wav")*/
    static normalizeMime(mimeType) {
        let value = mimeType.trim().toLowerCase();
        const index = value.indexOf(";");
        if (index > 0) {
            value = value.substring(0, index);
        }
        return value;
    }
    /** Convert a mime type to its common file extension */
    static mimeToFileExt(mimeType) {
        const ext = this.MimeToExtension.get(mimeType);
        if (!ext) {
            throw new Error(`Mime type "${mimeType}" is not supported`);
        }
        return ext;
    }
    /** Convert a mime type to its common file extension */
    static fileExtToMime(extension) {
        const mime = this.ExtensionToMime.get(extension);
        if (!mime) {
            throw new Error(`Exstension "${extension}" is not supported`);
        }
        return mime;
    }
    /** Is the given mime type supported by this application? */
    static isSupportedMime(mimeType) {
        return this.MimeToExtension.has(mimeType);
    }
    /** All supported mime types for the application */
    static get supportedMimes() {
        return this.PreferredMimes.map(value => value.name);
    }
    /** All supported file extensions for the application */
    static get supportedExtensions() {
        return this.PreferredMimes.map(value => value.ext);
    }
}
